<template>
  <div>
    <InputLabelBase
      v-if="label"
      :label="label"
      :tool-tip="toolTip"
      :helper-text="helperText"
      :description="description"
      :small="small"
    />
    <div class="relative">
      <textarea
        :id="label ? labelCleanUp(label) : ''"
        v-model="model"
        :name="label ? labelCleanUp(label) : ''"
        class="block w-full rounded-md border-none bg-white shadow-inner outline-none ring-1 ring-inset placeholder:text-grey-500 focus:text-grey-900 focus:ring-2 active:text-grey-900 disabled:cursor-not-allowed disabled:opacity-50"
        :placeholder="placeholder"
        :rows="rows ? rows : small ? 3 : 4"
        :maxlength="maxChars || 300"
        :class="[
          small ? 'px-2 py-1.5 text-sm' : 'px-3 py-2 text-base',
          error || maxCharLength
            ? 'ring-rose-700'
            : 'ring-grey-400 focus:ring-green-700',
        ]"
      />
      <div
        class="absolute bottom-2 right-3 text-xs"
        :class="maxCharLength ? 'text-rose-700' : 'text-grey-600'"
      >
        {{ (model as string).length }}/{{ maxChars }}
      </div>
    </div>
    <p
      v-if="error || hint || maxCharLength"
      class="mb-0 mt-1 text-sm"
      :class="error || maxCharLength ? 'text-rose-700' : 'text-grey-600'"
    >
      <span v-if="maxCharLength"> Maximum character limit reached </span>
      <span v-else>{{ error || hint }}</span>
    </p>
  </div>
</template>

<script setup lang="ts">
import { labelCleanUp } from "@/utils/formValidation";

export interface Props {
  small?: boolean;
  placeholder?: string;
  label?: string;
  toolTip?: string;
  helperText?: string;
  description?: string;
  hint?: string;
  error?: string;
  disabled?: boolean;
  maxChars?: number;
  rows?: string;
}
const model = defineModel<string>();
const props = withDefaults(defineProps<Props>(), {
  maxChars: 300,
  placeholder: "",
  label: "",
  toolTip: "",
  helperText: "",
  description: "",
  hint: "",
  error: "",
  disabled: false,
  rows: "",
});

const maxCharLength = computed(() => model.value?.length === props.maxChars);
</script>
